<template>
  <div id="app">
    <home />
  </div>
</template>
<script>
import Home from "@/views/Home.vue";

export default {
  name: "App",
  components: {
    Home
  }
};
</script>
<style >
@import url("https://fonts.googleapis.com/css?family=Itim&display=swap");

:root {
  /* --bg: #005eac;
  --bg-dark: #013d83;
  --bg-light: #7fb9fc; */

  --bg: #2c2b2b;
  --bg-dark: #000000;
  --bg-light: #979797;

  --bg-sec: #ebe7e7;
  --bg-sec-dark: #bebebe;
  --bg-sec-light: white;

  --accent: #b61702;
  --accent-light: #ec947ea4;
  --accent-dark: #a50101;

  --font: #cf4403;
  --font-dark: #b30f0f;
}
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: "Itim", sans-serif;
}
</style>
